export const AI_AGENTS_CLIENT_IDS = [710417, 9, 2, 14952];
export const WORKFLOW_TASKS_CLIENT_IDS = [710417, 2, 14952];
export const V1_V2_TABLE_CHOICE_CLIENT_IDS = [2];

export function hasAiBuilderAccessForClient(clientId) {
  const numericId = Number(clientId);
  return Number.isFinite(numericId) && AI_AGENTS_CLIENT_IDS.includes(numericId);
}

/**
 * Inline canvas editing is now always ON for all workflows.
 * The legacy pane/drawer UI is no longer used.
 */
export function isInlineCanvasEditingEnabled() {
  return true;
}

/**
 * Cohort allowlist for progressive rollout.
 * Empty array = enabled for all. Populated = only these client IDs.
 * Set to [] for full rollout.
 */
const CANONICAL_PLACEHOLDER_MAP_COHORT = [];
const SESSION_IO_V1_RENDERING_COHORT = [];
const LIGHTWEIGHT_CANVAS_LOAD_COHORT = [];

export function isCanonicalPlaceholderMapEnabled(clientId) {
  if (typeof window === "undefined") return true;
  try {
    if (window.localStorage.getItem("wf86.disablePlaceholderMapV2") === "1")
      return false;
  } catch (_) {}

  if (CANONICAL_PLACEHOLDER_MAP_COHORT.length > 0 && clientId != null) {
    return CANONICAL_PLACEHOLDER_MAP_COHORT.includes(Number(clientId));
  }
  return true;
}

export function isSessionIoV1RenderingEnabled(clientId) {
  if (typeof window === "undefined") return true;
  try {
    if (window.localStorage.getItem("wf86.disableSessionIoV1Rendering") === "1")
      return false;
  } catch (_) {}

  if (SESSION_IO_V1_RENDERING_COHORT.length > 0 && clientId != null) {
    return SESSION_IO_V1_RENDERING_COHORT.includes(Number(clientId));
  }
  return true;
}

export function isLightweightCanvasLoadEnabled(clientId) {
  if (typeof window === "undefined") return true;
  try {
    if (
      window.localStorage.getItem("wf86.disableLightweightCanvasLoad") === "1"
    )
      return false;
    if (window.localStorage.getItem("wf86.enableLightweightCanvasLoad") === "1")
      return true;
  } catch (_) {}

  if (LIGHTWEIGHT_CANVAS_LOAD_COHORT.length > 0 && clientId != null) {
    return LIGHTWEIGHT_CANVAS_LOAD_COHORT.includes(Number(clientId));
  }
  return true;
}

export function isTypedChatChunksEnabled() {
  return true;
}
export function isTypedChatRendererEnabled() {
  return true;
}
export function isTypedChatTransportEnabled() {
  return true;
}
